<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Çalışma Türü</label>
            <select class="form-control" v-model="value.EmployeeWorkingTypeId">
                <option :value="null">Seçiniz</option>
                <option v-for="type in types" :key="type.Code" :value="type.Id">{{type.Name}}</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        types:{
            type:Array,
            default:()=>[]
        }
    },
}
</script>

<style>

</style>